import { CloudOff, CloudUpload, RefreshCw } from "lucide-react";
import { useOfflineQueue } from "../offline/photoQueue";

// Shows only when the phone is offline or photos are waiting to upload.
export function OfflineQueueBanner() {
  const { count, online, flush } = useOfflineQueue();
  if (online && !count) return null;
  return (
    <div className={`mb-3 flex items-center gap-2.5 rounded-md border px-3 py-2 text-[13px] ${online ? "border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200" : "border-line bg-surface-2 t2"}`} data-testid="offline-queue-banner" data-online={String(online)} data-count={count}>
      {online ? <CloudUpload size={16} className="shrink-0 text-amber-600" /> : <CloudOff size={16} className="t3 shrink-0" />}
      <span className="min-w-0 flex-1">
        {!online ? <><b className="t1 font-semibold">You're offline.</b> {count ? `${count} photo${count > 1 ? "s" : ""} saved on this phone — ` : "Photos you take are saved on this phone and "}upload{count ? "s" : ""} automatically when you're back in range.</> : <><b className="font-semibold">{count} photo{count > 1 ? "s" : ""} waiting to upload</b> from when you were offline.</>}
      </span>
      {online && <button className="btn-secondary btn-sm shrink-0" onClick={flush} data-testid="offline-queue-upload-now"><RefreshCw size={12} /> Upload now</button>}
    </div>
  );
}
